import type { ActivityDefinition, SchoolLevel } from "./catalog";
import type { LibraryState } from "./activity-library";
import { associatedWithClass } from "./class-assignments";

/** Read-only projection: the library is authoritative; old session entries remain compatible. */
export function sessionActivityOptions(
  legacy: ActivityDefinition[], state: LibraryState | undefined,
  classId: string, schoolLevel: SchoolLevel, currentActivityId?: string,
): ActivityDefinition[] {
  const candidates = new Map(legacy.map(a => [a.id, a]));
  for (const a of state?.activities ?? []) candidates.set(a.id, {
    id: a.id, title: a.title, schoolLevel: a.levelTitle as SchoolLevel,
    theme: a.themeTitle, chapter: a.chapterTitle,
    coefficient: a.coefficient, competencyIds: a.competenceIds,
  });
  return [...candidates.values()].filter(a => {
    if (state?.deletedActivities?.some(deleted=>deleted.id===a.id)) return false;
    if (a.schoolLevel !== schoolLevel) return false;
    if (a.id === currentActivityId) return true;
    if (state?.activities.find(item => item.id === a.id)?.archived) return false;
    if (state && associatedWithClass(state, a.id, classId)) return true;
    if (state?.digitalSessions?.some(d => d.classId === classId && d.activityId === a.id && !d.endedAt)) return true;
    // Unassigned library activities are available to launch for their level too.
    // This does not grant student access: launching still creates the session.
    // An explicit assignment (including an inactive one) must still take precedence.
    return !state?.assignments.some(item => item.activityId === a.id && !item.sessionId);
  });
}
